import { useState, useCallback } from 'react';
import { useEventListener } from 'hooks/useEventListener';
import { getStoredThemeId, getStoredThemeMode, isThemeDark } from 'theme';

const LOGO_LIGHT_BG = '/eir-logo-light-bg.svg';
const LOGO_DARK_BG = '/eir-logo-dark-bg.svg';

export const getThemeLogoSrc = (): string => {
  const themeId = getStoredThemeId();
  const mode = getStoredThemeMode();
  return isThemeDark(themeId, mode) ? LOGO_DARK_BG : LOGO_LIGHT_BG;
};

export const useThemeLogo = (): string => {
  const [logoSrc, setLogoSrc] = useState(getThemeLogoSrc);

  const refresh = useCallback(() => {
    setLogoSrc(getThemeLogoSrc());
  }, []);

  useEventListener('profileUpdated', refresh);
  useEventListener('storage', refresh);

  return logoSrc;
};
